import React, { useState, useEffect, useRef } from 'react';
import { MdClose } from "react-icons/md";

import GlobalContext from "./GlobalContext";

const FilterSearch = () => {
  const global = React.useContext(GlobalContext);
  const [searchValue, setSearchValue] = useState('');
  const timerRef = useRef(null);

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleClear = () => {
    setSearchValue('');
    global.actions.changeFilterQuery('');
  };

  useEffect(() => {
    if (searchValue.length >= 3) {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        global.actions.changeFilterQuery(searchValue);
      }, 1000);
    }
  }, [searchValue, global.actions]);

  return (
    <div className='filter-search'>
      <img class='search' src='/wp-content/plugins/artsongs-blocks/images/search.svg' alt='search icon' />
      <input 
        onChange={handleChange}
        placeholder='Search by title'
        type='text'
        value={searchValue}
      />
      {searchValue && <MdClose class='clear' onClick={handleClear} />}
    </div>
  );
};

export default FilterSearch;